import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const min5LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 5});
const min6LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 6});
const min3LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 3});
const max255LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 255});
const max500LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 500});
const phoneFormatMessage = () => i18n.t("validation.phoneFormat", {ns: "common"});
const emailFormatMessage = () => i18n.t("validation.emailFormat", {ns: "common"});
const tcknFormatMessage = () => i18n.t("validation.tcknFormat", {ns: "common"});
const ibanFormatMessage = () => i18n.t("validation.ibanFormat", {ns: "common"});

export const newCourierValidation = yup.object().shape({
    fullname: yup
        .string()
        .min(6, min6LengthsMessage)
        .max(255, max255LengthsMessage)
        .required(requiredMessage),
    type: yup.string().required(requiredMessage),
    // regions: yup.array().required(requiredMessage),
    cellPhone: yup
        .string()
        .matches(/^0(\(([0-9]{3}\)-[0-9]{3}-[0-9]{4}))|([0-9]{10}$)/, phoneFormatMessage)
        .required(requiredMessage),
    email: yup
        .string()
        .email(emailFormatMessage)
        .required(requiredMessage),
    birthDate: yup.date().required(requiredMessage),
    tckn: yup
        .string()
        .matches(/^[1-9]{1}[0-9]{9}[2,4,6,8,0]{1}$/, tcknFormatMessage)
        .required(requiredMessage),
    bloodGroup: yup.string().nullable(),
    address: yup
        .string()
        .min(5, min5LengthsMessage)
        .max(500, max500LengthsMessage)
        .required(requiredMessage),
    vehicleInfo: yup.string().required(requiredMessage),
    // Yeni kurye oluştururken (activationStep/activationPhase henüz yok) her zaman zorunlu.
    // Mevcut bir kurye düzenlenirken, proje adımına henüz gelmemişse zorunlu değil.
    managerCompany: yup
        .string()
        .when(["activationStep", "activationPhase"], (activationStep, activationPhase, schema) => {
            const isBeforeProjectPhase =
                activationStep === "candidate" &&
                ["none", "companySetup", "newApplication", "document"].includes(activationPhase);
            return isBeforeProjectPhase
                ? schema.nullable().optional()
                : schema.oneOf(["vigo", "agency"], requiredMessage).required(requiredMessage);
        }),
    emergencyContactName: yup
        .string()
        .min(3, min3LengthsMessage)
        .max(255, max255LengthsMessage)
        .required(requiredMessage)
        .nullable(),
    emergencyContactPhone: yup
        .string()
        .matches(/^0(\(([0-9]{3}\)-[0-9]{3}-[0-9]{4}))|([0-9]{10}$)/, phoneFormatMessage)
        .required(requiredMessage)
        .nullable(),
    emergencyContactDegree: yup
        .string()
        .required(requiredMessage)
        .nullable(),
    city: yup.string().required(requiredMessage),
    county: yup.string().required(requiredMessage),
    bankName: yup.string().required(requiredMessage),
    iban: yup
        .string()
        .matches(/^TR[0-9]{24}$/, ibanFormatMessage)
        .required(requiredMessage),
    photo: yup.mixed(),
    gender: yup.string().required(requiredMessage),
    homeLocation: yup.object().shape({
        longitude: yup.number().required(requiredMessage),
        latitude: yup.number().required(requiredMessage)
    }),
    vehicleOwnership: yup
        .string()
        .nullable()
        .optional(),
    hasBagRegistered: yup
        .boolean()
        .nullable()
        .optional(),
    hasProfessionalCompetenceCertificate: yup
        .boolean()
        .nullable()
        .optional(),
    vionTransitionDate: yup
        .date()
        .nullable()
        .optional(),
    licensePlate: yup
        .string()
        .nullable()
        .test("valid-license-plate", function(value) {
            // Boş ise geçerli (zorunlu değil)
            if (!value || value.trim() === "") {
                return true;
            }

            // Boşlukları temizle ve büyük harfe çevir
            const cleanValue = value.replace(/\s/g, "").toUpperCase();

            // Yasak karakterleri kontrol et (Türkçe: Ç,Ş,İ,Ö,Ü,Ğ ve Latin: Q,W,X)
            const forbiddenChars = /[ÇŞİÖÜĞQWX]/;
            if (forbiddenChars.test(cleanValue)) {
                return this.createError({
                    message: "Plaka Ç, Ş, İ, Ö, Ü, Ğ, Q, W, X harflerini içeremez"
                });
            }

            // Geçerli pattern: 2 rakam + 1-3 harf + 1-4 rakam
            const pattern = /^[0-9]{2}[A-Z]{1,3}[0-9]{1,4}$/;
            if (!pattern.test(cleanValue)) {
                return this.createError({
                    message: i18n.t("validation.licensePlateFormat", {ns: "common"})
                });
            }
            // Harf ve rakam sayısını kontrol et
            const letters = cleanValue.substring(2).replace(/[0-9]/g, "");
            const digits = cleanValue.substring(2 + letters.length);

            if (letters.length < 1 || letters.length > 3) {
                return this.createError({
                    message: "Plaka 1-3 harf içermelidir"
                });
            }

            if (digits.length < 1 || digits.length > 4) {
                return this.createError({
                    message: "Plaka 1-4 rakam içermelidir"
                });
            }

            return true;
        })
});
